import { SET_ERROR } from '../mutations/common.mutations';
import { LOG_ACTIVITY } from '@/store/actions/activity.actions';
import {SET_ACTIVITIES, TRY_FETCH_ACTIVITIES} from '@/store/mutations/activity.mutations';
import ActivityService from '@/common/services/activity.service';

const state = {
  pending: false,
  errors: [],
  user: null,
  pages: [],
  loaded: false,
  selectedPage: null
};

const actions = {
  [LOG_ACTIVITY](context, {activityType, activityData}) {
      return ActivityService.logActivity(activityType, activityData)
  }
};

const mutations = {
  [TRY_FETCH_ACTIVITIES](state) {
    state.pending = true;
    state.errors = [];
  },
  [SET_ERROR](state, errors) {
    state.pending = false;
    state.errors = errors;
  },
  [SET_ACTIVITIES](state, activities) {
    state.pending = false;
    state.errors = [];
    state.entities = activities;
    state.loaded = true;
  }
};

const getters = {
  activities: state => {
    return state.entities
  },
  activitiesLoaded: state => {
    return state.loaded;
  },
  activitiesPending: state => {
    return state.pending;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
